interface Vet {
    vet_id: number,
    user_id: number,
    name: string
    email: string,
    password: string,
    confirmation: string,
    type: string,
    phone: string,
    specialty: string,
    account_token: string,
    discount: number
}

interface vetToken {
    vet_id: number,
    account_token: string
}

/* Newest version - unique profile */
interface VetAurinkoProfile {
    vet_id: number,
    aurinko_profile_id: number
}

interface WorkingInterval {
    start: string,
    end: string
}

interface DayAvailability {
    date: string,
    name: string,
    hours: WorkingInterval[]
}

interface AvailabilityWeek {
    number: number,
    date_start: string,
    date_end: string,
    week_availability: DayAvailability[]  
}

interface DaySchedule {
    dayOfWeek: string,
    workingIntervals: WorkingInterval[]
}

interface AvailabilityInterval {
    dateStartInclusive: string,
    dateEndInclusive: string,
    hours : WorkingInterval[]
}

interface AvailabilityConfig {
    id: number,
    name: string,
    durationMinutes: number,
    availabilityStep: number,
    timeAvailableFor: string,
    subject: string,
    description: string,
    location: string,
    workHours:
    {
        timezone: string,
        daySchedules: DaySchedule[],
    },
    availabilityIntervals:
    {
        intervals: AvailabilityInterval[]
    },
    context: string,
    startConference: boolean
}

interface createVetAvailabilityProfileParams {
    vet_id: number,
    id: number,
    name: string,
    durationMinutes: number,
    availabilityStep: number,
    timeAvailableFor: string,
    subject: string,
    description: string,
    location: string,
    workHours:
    {
        timezone: string,
        daySchedules: DaySchedule[],
    },
    context: string,
    startConference: boolean
}

interface IniVetAppointmentsParams {
    vetId: number,
    language: string
}

interface VetAppointment {
    appointment_id: number,
    schedule: string,
    customer_user_id: number,
    customer_name: string,
    pet_id: number,
    pet_name: string,
    vet_user_id: number,
    description: string,
    price: number,
    customer_pin: number,
    vet_pin: number,
    appointment_status_key: string,
    appointment_status: string,
    status_date: string
}

interface VetWithAvailability  {
    vet_id: number,
    name: string,
    email: string,
    specialty: string,
    availability_config: AvailabilityConfig,
    availability?: DayAvailability[]   
}


const vetResetState = () => ({
    editedVetData: {
        vet_id: 0,
        user_id: 0,
        name: '',
        email: '',
        password: '',
        confirmation: '',
        type: 'vet',
        phone: '',
        specialty: '',
        account_token: '',
        discount: 0
    },
    aurinkoProfiles: [] as VetAurinkoProfile[],
    editingVet: false,
    vetMode: 'availabilityconfig',
    hasAssociatedCalendar: false,
    vetRecord: [] as VetAppointment [],
    availableVetsUserIDs: [] as number [],
    vetsAvailability: [] as VetWithAvailability[]
});

export const editedVet = {
    state: vetResetState(),

    getters: {

        getEditedVetData(state: any): Vet {
            return (state.editedVetData)
        },
        getAurinkoProfiles(state: any): Vet {
            return (state.aurinkoProfiles)
        },
        getEditingVet(state: any): boolean {
            return (state.editingVet)
        },
        getVetMode(state: any): string {
            return (state.vetMode)
        },
        getHasAssociatedCalendar(state: any): boolean {
            return (state.hasAssociatedCalendar)
        },
        getVetRecord(state: any): VetAppointment[] {
            return (state.vetRecord)
        },
        getAvailableVetsUserIDs(state: any): number[] {
            return (state.availableVetsUserIDs)
        },
        getVetsAvailability(state: any): VetWithAvailability[] {
            return (state.vetsAvailability)
        },
        getFlattenedAvailabilities(state: any): any[] {
            return (state.flattenedAvailabilities)  
        }
    },
    mutations: {

        setEditedUserData(state: any, editedUserData: any) {
            state.editedVetData.user_id = editedUserData.user_id;
            state.editedVetData.email = editedUserData.email;
            state.editedVetData.name = editedUserData.name;
            state.editedVetData.vet_id = editedUserData.vet_id;
            state.editedVetData.phone = editedUserData.phone;
            state.editedVetData.account_token = editedUserData.account_token;
            state.editedVetData.discount = editedUserData.discount;
        },

        setEditedVetData(state: any, editedVetData: any) {
            state.editedVetData = editedVetData
        },

        setAurinkoProfiles(state: any, aurinkoProfiles: VetAurinkoProfile[]) {
            state.aurinkoProfiles = aurinkoProfiles
        },
        setEditingVet(state: any, editingVet: boolean) {
            state.editingVet = editingVet
        },
        setVetMode(state: any, newVetMode: string) {
            state.vetMode = newVetMode
        },
        setHasAssociatedCalendar(state: any, hasAssociatedCalendar: boolean) {
            state.hasAssociatedCalendar = hasAssociatedCalendar
        },
        setVetRecord(state: any, vetRecord: VetAppointment[]) {
            console.log("setVetRecord");
            console.log(vetRecord);
            console.log(typeof (vetRecord));
            state.vetRecord = [];
            vetRecord.forEach((vetrecord: any) => {
                console.log(vetrecord);
                state.vetRecord.push(vetrecord)
            });
        },

        /* Full reset of the vet module state */
        vetResetStateMut(state: any)
        {
            Object.assign(state, vetResetState())
        },

        // Reset only the transient data, keep the editedVetData, vetMode, etc.
        vetResetTransientMut(state: any) 
        {
            state.aurinkoProfiles = [];
            state.editedVetSpecialties = [];
            state.vetRecord = [];
            state.availableVetsUserIDs = [];
            // keep editedVetData, vetMode, etc.
        },
        setAvailableVetsUserIDs(state: any, availVetsUserIDs: number[]) {
            console.log("setAvailableVetsUserIDs");
            console.log(availVetsUserIDs);
            console.log(typeof (availVetsUserIDs));
            state.availableVetsUserIDs = [];
            availVetsUserIDs.forEach((vetUserID: any) => {
                console.log(vetUserID);
                state.availableVetsUserIDs.push(vetUserID)
            });
        },
        setVetsAvailability(state: any, vetsAvailability: VetWithAvailability[]) {
            console.log("setVetsAvailability");
            state.vetsAvailability = vetsAvailability;
        }
    },
    actions: {

        /* Reset only the transient data, keep the editedVetData, vetMode, etc. */
        resetEditVetTransientState(state: any)
        {
            state.commit('vetResetTransientMut');
        },
        
        async iniEditedVet(state: any, vetEmail: string) {

            console.log("iniEditedVet")

            try {
                const response = await fetch(process.env.BASE_URL + `api/users/vet/byemail/${vetEmail}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${state.getters.token}`
                    }
                });

                if (!response.ok) {
                    throw new Error('Failed to fetch vet data');
                }

                const vetData = await response.json();
                console.log(vetData);
                console.log(vetData.user_id);
                state.commit('setEditedVetData', vetData);
                console.log(vetData.email);
                 
                // Only call fetchVetAurinkoProfiles if the vet has an account token / an associated calendar 
                if(vetData.account_token === "" || vetData.account_token === null)
                {
                    state.commit('setHasAssociatedCalendar', false);
                }
                else
                {
                    // Call fetchVetAurinkoProfiles with vetId
                    state.commit('setHasAssociatedCalendar', true);
                    await state.dispatch('fetchVetAurinkoProfiles', vetData.vet_id);
                }

                return vetData; // Resolve the promise with the fetched vet data

            } catch (error) {
                console.error('Error fetching vet data:', error);
                throw error; // Re-throw the error to be caught by the caller
            }

        },

        async fetchVetAurinkoProfiles(state: any, vetId: string) {

            console.log("fetchVetAurinkoProfiles");

            try {
                const response = await fetch(process.env.BASE_URL + `api/vets/aurinkoprofiles/${vetId}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${state.getters.token}`,
                    }
                });
        
                if (!response.ok) {
                    throw new Error('Failed to fetch aurinko profiles');
                }
        
                const aurinkoProfiles = await response.json();
                state.commit('setAurinkoProfiles', aurinkoProfiles);
                return aurinkoProfiles;
            } catch (error) {
                throw error;
            }
        },

        async iniVetDetailing(state: any, vetData: any) {

            console.log("iniVetDetailing")

            console.log(vetData);
            console.log(vetData.user_id);
            state.commit('setEditedUserData', vetData)
        },


        iniVetEditing(state: any) {

            state.commit('setEditingVet', true);
        },

        endVetEditing(state: any) {

            state.commit('setEditingVet', false);
        },

        async editVet(state: any, editedVetData: Vet) {
            console.log(JSON.stringify(editedVetData))
            const response = await fetch(process.env.BASE_URL + `api/users/vet/` + editedVetData.user_id.toString(), {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${state.getters.token}`,
                },
                body: JSON.stringify(editedVetData),
            })

            var editedVetId: number = 0

            if (response.ok) {
                const resjson = await response.json()
                editedVetId = resjson.user_id

            } else {
                throw new Error('error_updating_vet')
            }
            return (editedVetId)
        },

        async updateVetToken(state: any, vetTokenData: vetToken) {
            console.log(JSON.stringify(vetTokenData))
            const response = await fetch(process.env.BASE_URL + `api/vets/token/` + vetTokenData.vet_id.toString(), {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${state.getters.token}`,
                },
                body: JSON.stringify(vetTokenData),
            })

            var editedVetId: number = 0

            if (response.ok) {
                const resjson = await response.json()
                editedVetId = resjson.vet_id

            } else {
                throw new Error('error_updating_token')
            }
            return (editedVetId)
        },

        async removeVetCalendarAssociation(state: any, vetId: number) {
            console.log(vetId)
            const response = await fetch(process.env.BASE_URL + `api/vets/removecalendarassociation/` + vetId.toString(), {
                method: 'PUT',
                headers: {
                    Authorization: `Bearer ${state.getters.token}`,
                },
            })

            var editedVetId: number = 0

            if (response.ok) {
                const resjson = await response.json()
                editedVetId = resjson.vet_id

            } else {
                throw new Error('error_removing_token')
            }
            return (editedVetId)
        },

        

        iniVetAvailabilityConfig(state: any) {
            state.commit('setVetMode', "availabilityconfig");
        },

        iniVetAvailabilitySlots(state: any) {
            state.commit('setVetMode', "availabilityslots");
        },

        iniVetCustomers(state: any) {
            state.commit('setVetMode', "customers");
        },
        iniVetAppointments(state: any) {
            state.commit('setVetMode', "appointments");
        },
        async iniVetRecord(state : any, params : IniVetAppointmentsParams) {
            console.log("iniVetRecord");
            console.log(params.vetId);
            console.log(params.language);
            console.log(process.env.BASE_URL + `api/vets/record/` + params.vetId.toString( ) + '/' + params.language);

            return (new Promise((resolve, reject) => {
                fetch(process.env.BASE_URL + `api/vets/record/` + params.vetId.toString( ) + '/' + params.language,
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${state.getters.token}`,
                        }
                    })
                    .then((res) => res.json())
                    .then((vet_record_data) => {
                        console.log(vet_record_data);
                        console.log(typeof (vet_record_data));
                        state.commit('setVetRecord', vet_record_data)
                        resolve(vet_record_data)
                    })
                    .catch(err => reject(err))
            }))
        },
        async fetchAvailableVetsUserIDs(state : any, date : string) {
            console.log("fetchAvailableVetsUserIDs");
            console.log(date);
            
            // Remove hyphens from the date string
            const urlSafeDate = date.replace(/-/g, '');

            console.log(process.env.BASE_URL + `api/vets/withavailability/` + urlSafeDate);

            return (new Promise((resolve, reject) => {
                fetch(process.env.BASE_URL + `api/vets/withavailability/` + urlSafeDate,
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${state.getters.token}`,
                        }
                    })
                    .then((res) => res.json())
                    .then((vet_user_ids_data) => {
                        console.log(vet_user_ids_data);
                        console.log(typeof (vet_user_ids_data));
                        state.commit('setAvailableVetsUserIDs', vet_user_ids_data)
                        resolve(vet_user_ids_data)
                    })
                    .catch(err => reject(err))
            }))
        },
        
        async fetchVetsAvailability(state: any)
        {
            const response = await fetch(process.env.BASE_URL + `api/vets/all_availabilities`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${state.getters.token}`,
                }
            });

            if (!response.ok) throw new Error('Failed to fetch vets availability');

            const data = await response.json();

            // Transform each vet availability
            const vetsAvailability: VetWithAvailability[] = Object.values(data).map((vet: any) => {
                const availability: DayAvailability[] = [];

                if (vet.availability_config?.availabilityIntervals?.intervals) {
                    vet.availability_config.availabilityIntervals.intervals.forEach((interval: AvailabilityInterval) => {
                        // One DayAvailability per date
                        availability.push({
                            date: interval.dateStartInclusive,
                            name: vet.name,
                            hours: interval.hours
                        });
                    });
                }

                return {
                    ...vet,
                    availability   // add derived data
                } as VetWithAvailability;
            });

            state.commit('setVetsAvailability', vetsAvailability);
        }

    }
}

const editedAvailabilityConfigResetState = () => ({
    editedAvailabilityConfigData:
    {
        id: 0,
        name: '',
        durationMinutes: 0,
        availabilityStep: 0,
        timeAvailableFor: 'P10W',
        subject: '',
        description: 'Vet appointments',
        location: 'Jitsi video call',
        workHours:
        {
            timezone: 'GMT',
            daySchedules: [{"dayOfWeek": "monday", "workingIntervals": []}],
        },
        availabilityIntervals : 
        {
            intervals : []
        },
        context: '',
        startConference: true
    },

    timeLimits: [] as string[],
    /*creatingAvailabilityConfig: false*/
});

export const editedAvailabilityConfig = {
    state: editedAvailabilityConfigResetState(),

    getters: {
        getEditedAvailabilityConfigData(state: any): AvailabilityConfig {
            return (state.editedAvailabilityConfigData)
        },

        getEditedDaySchedules(state: any): DaySchedule[] {
            return (state.editedAvailabilityConfigData.workHours.daySchedules.slice())
        },
        
        getAvailabilityIntervals(state: any): AvailabilityInterval[] {
            return (state.editedAvailabilityConfigData.availabilityIntervals.intervals.slice())
        },

        getTimeLimits(state: any): string[] {
            return (state.timeLimits)
        },
        
        getAvailabilityWeeks(state: any, getters: any): AvailabilityWeek[]
        {
            console.log("getAvailabilityWeeks");
            const weeks: AvailabilityWeek[] = [];
            const currentDate = new Date();
            console.log("currentDate", currentDate);

            // Helper function to format a Date as yyyy-mm-dd. New version that works with time daylight saving changes
            const formatDate = (date: Date): string => {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };

            // Helper function to get the start of the week (e.g., Monday)
            const getStartOfWeek = (date: Date): Date => {
                const day = date.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
                const diff = (day === 0 ? -6 : 1) - day; // Shift days to get Monday as start
                const start = new Date(date);
                start.setDate(date.getDate() + diff);
                start.setHours(0, 0, 0, 0); // Set time to midnight
                return start;
            };

            // Helper function to get the name of a day
            const getDayName = (date: Date): string => {
                const daysOfWeek = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
                return daysOfWeek[date.getDay()];
            };

            const getISOWeekNumber = (date: Date): { year: number; week: number } =>
            {
                const tmp = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
                const dayNum = tmp.getUTCDay() || 7;
                tmp.setUTCDate(tmp.getUTCDate() + 4 - dayNum);
                const yearStart = new Date(Date.UTC(tmp.getUTCFullYear(), 0, 1));
                const weekNo = Math.ceil((((tmp.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
                return { year: tmp.getUTCFullYear(), week: weekNo };
            };

            // Start iterating from the current week
            let startOfWeek = getStartOfWeek(currentDate);
            console.log("startOfWeek", startOfWeek);

            // Iterate for the number of weeks ahead specified in the environment variable
            for (let week = 0; week < process.env.VUE_APP_SCHEDULING_WEEKS_AHEAD; week++) {
                const daysOfWeek: DayAvailability[] = [];

                for (let day = 0; day < 7; day++) {
                    const date = new Date(startOfWeek.getTime() + day * 86400000); // Safely shift by days
                    let dateStr = formatDate(date);
                    
                    // Use the getter to get the availability intervals
                    const availabilityIntervals = getters.getAvailabilityIntervals;  // Access the getter
                    const dayAvailability = availabilityIntervals.find(
                        (element: any) => element.dateStartInclusive === dateStr
                    );
                    daysOfWeek.push({
                        date: dateStr,
                        name: getDayName(date),
                        hours: dayAvailability ? dayAvailability.hours : []
                    });
                }

                // Calculate ISO year and week number
                const { year, week: isoWeek } = getISOWeekNumber(startOfWeek);


                weeks.push({
                    number: parseInt(`${year}${String(isoWeek).padStart(2, '0')}`), // Format as yyyynn
                    date_start: formatDate(startOfWeek), // First day of the week
                    date_end: formatDate(new Date(startOfWeek.getTime() + 6 * 86400000)), // Add 6 days
                    week_availability: daysOfWeek                   // All 7 days with dates and names
                });

                // Move to the next week without mutating the original date
                startOfWeek.setDate(startOfWeek.getDate() + 7);
                startOfWeek.setHours(0, 0, 0, 0);}
            
            return weeks;
        }
    },
    mutations: {

        setEditedAvailabilityConfigData(state: any, availabilityConfigData: any) {

            state.editedAvailabilityConfigData = availabilityConfigData
        },

        /* Old version - several profiles
        setEditedDaySchedules(state: any, editedDaySchedules: any) {
            console.log("setEditedDaySchedules");
            console.log(editedDaySchedules);
            console.log(typeof (editedDaySchedules));
            state.editedAvailabilityConfigData.workHours = Object.assign({}, state.editedAvailabilityConfigData.workHours, { daySchedules: editedDaySchedules })
        },
        */
        
        // New version - unique profile
        setEditedDaySchedules(state: any, editedDaySchedules: any) {
            console.log("setEditedDaySchedules");
            console.log(editedDaySchedules);
            console.log(typeof (editedDaySchedules));
            // find the entry in intervals that has the same date as the editedDaySchedules
            // and update the hours
            let intervals = state.editedAvailabilityConfigData.availabilityIntervals.intervals
            // find the index of the interval that has the same dateStartInclusive as the editedDaySchedules
            let index = intervals.findIndex((element: any) => element.dateStartInclusive === editedDaySchedules[0].dateStartInclusive)
            // update the hours of the interval
            intervals[index].hours = editedDaySchedules[0].hours
            // update the state
            state.editedAvailabilityConfigData.availabilityIntervals.intervals = intervals         
        },

        setTimeLimits(state: any, newTimeLimits: string[]) {
            state.timeLimits = newTimeLimits
        },
        editedAvailabilityConfigResetStateMut(state: any) {
            Object.assign(state, editedAvailabilityConfigResetState())
        },
        
    },
    actions: {

        async iniEditedAvailabilityConfig(state: any, {vetId, aurinkoProfileId} : {vetId: number, aurinkoProfileId: number})
        {
            console.log("iniEditedAvailabilityConfig");
            
            try {
                const response = await fetch(process.env.BASE_URL + `api/vets/availability/${vetId}/${aurinkoProfileId}`,
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${state.getters.token}`,
                        }
                    });

                if (!response.ok) {
                    throw new Error('Failed to fetch availability configuration data');
                }

                const availabilityConfig = await response.json();
                console.log(availabilityConfig);
                state.commit('setEditedAvailabilityConfigData', availabilityConfig);

                return availabilityConfig; // Resolve the promise with the fetched availability configuration data
            } catch (error) {
                console.error('Error fetching availability configuration data:', error);
                throw error; // Re-throw the error to be caught by the caller
            }
        },
        
        async iniEditedAvailabilityConfigTimeLimits(state: any) {

            console.log("iniEditedAvailabilityConfigTimeLimits")

            return (new Promise((resolve, reject) => {
                fetch(process.env.BASE_URL + `api/vets/time-limits`,
                    {
                        method: 'GET',
                        headers: {
                            Authorization: `Bearer ${state.getters.token}`,
                        }
                    })
                    .then((res) => res.json())
                    .then((time_limits) => {
                        console.log(time_limits);
                        state.commit('setTimeLimits', time_limits)
                        resolve(time_limits)
                    })
                    .catch(err => reject(err))
            }))

        },
        updateEditedDaySchedules(state: any, editedDaySchedules: DaySchedule[]) {
            console.log("updateEditedDaySchedules")
            console.log(editedDaySchedules)
            state.commit('setEditedDaySchedules', editedDaySchedules)
        },

        async updateVetAvailabilityProfile(state: any, {vetId, updatedAvailabilityProfile} : {vetId: number, updatedAvailabilityProfile: AvailabilityConfig} )
        {

            const response = await fetch(process.env.BASE_URL + `api/vets/availability/${vetId}/${updatedAvailabilityProfile.id}`,
            {
                method: 'PATCH',
                body: JSON.stringify(updatedAvailabilityProfile),
                headers: {
                    Authorization: `Bearer ${state.getters.token}`,
                }
            })

            if (response.ok) {
                return response.json
            } else {
                throw new Error('error_updating_availability_profile')
            }
        }
        
    }
}
